// extracted by mini-css-extract-plugin
export var contactLinks = "Faqs-module--contactLinks--3f22e";
export var faqs = "Faqs-module--faqs--79d0c";
export var sectionTitle = "Faqs-module--sectionTitle--47864";